import styled from "styled-components";

export const ChatbotInput = styled.div`
  display: flex;
  color: var(--blue-color);
  align-items: center;
  justify-content: space-evenly;
  .form-container {
    border-radius: 20px;
    background-color: #fafafc;
    align-items: center;
    width: 100%;
    border: 1px solid #efeff9;
    display: ${({ smallInput }) => smallInput && "flex"};
    &__disabled-icon {
      position: absolute;
      margin-left: 60px;
      font-size: 20px;
    }
  }
  .send-icon-container {
    margin-right: 20px;
  }
  textarea {
    border: none;
    background-color: transparent;
    opacity: ${({ chatbotDisabled }) => (chatbotDisabled ? "0.6" : "1")};
    padding: ${({ chatbotDisabled, smallInput }) =>
      chatbotDisabled ? "18px 0px 18px 20px" : "16px 0px 16px 20px"};
    box-sizing: border-box;
    overflow-y: scroll;
    outline: none;
    font-size: ${({ chatbotDisabled }) => (chatbotDisabled ? "14px" : "16px")};
    color: var(--blue-color);
    resize: none;
    height: 56px;
    max-height: 80px;
    /* width: calc(100% - 45px); */
    width: 100%;
    color: #3e3da3;
    font-family: "Nunito Sans";
    ::-webkit-scrollbar {
      width: 40px;
    }
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 10px 10px transparent;
      /* margin: 1px 0px;  */
    }
    ::-webkit-scrollbar-thumb {
      border: 17px solid rgba(0, 0, 0, 0);
      box-shadow: inset 0 0 10px 10px #3e3da366;
      background-clip: padding-box;
      border-radius: 9999px;
      background-color: transparent;
    }
    ::placeholder {
      color: #707582;
      font-family: "Nunito Sans";
    }
  }
  .buttons {
    padding: ${({ smallInput }) =>
      smallInput ? "0px 20px 0px 0px" : "5px 20px 20px 20px"};
    justify-items: end;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .button-chat-options {
    background-color: #fff;
    border: none;
    border-radius: 14px;
    width: 36px;
    height: 36px;
    cursor: pointer;
    display: flex;
    i {
      color: #16158a;
      font-size: 13px;
      margin: auto;
    }
  }
  .button-send {
    background-color: ${({ chatbotDisabled }) =>
      chatbotDisabled ? "#CFD3DD" : "#2a28d6"};
    color: #fff;
    border: none;
    border-radius: 14px;
    width: 36px;
    height: 36px;
    outline: none;
    cursor: ${({ chatbotDisabled }) => (chatbotDisabled ? "auto" : "pointer")};
    display: flex;
    i {
      color: #fff;
      font-size: 18px;
      margin: auto;
      rotate: 270deg;
    }
  }
  .chatbot-footer {
    background-color: white;
  }
`;

export const MessagesTypes = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #efeff6f2;
  height: auto;
  overflow-y: auto;
  border-radius: 20px;
  box-shadow: 0px 3px 6px #00000029;
  text-align: center;
  padding: 20px;
  border: 2px solid #ffffff;
  &::-webkit-scrollbar {
    display: none;
  }
  .chat-setting-box {
    min-width: 300px;
    font-family: "Nunito";
    font-size: 15px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
    cursor: pointer;
    &__text {
      font-size: 20px;
      font-family: "Nunito Sans";
      color: #1f1f52;
    }
    .icono-settings {
      font-size: 20px;
      display: flex;
      color: #3e3e5b;
    }
  }
`;
